/* eslint-disable no-control-regex */
import * as Yup from 'yup';
import { address, creditCardHolderName } from 'validation';

export default Yup.object({
  creditCardHolderName,
  address
});
